import React from "react";
import styled from "styled-components";

import ViewAppBar from "../views/ViewAppBar";
import ViewCadastroCotas from "../views/ViewCadastroCotas";

import ViewFooter from "../views/ViewFooter";

const ContainerComponente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 20px;

  @media (min-width: 200px) and (max-width: 399px) {
    padding: 8px;
    gap: 10px;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    flex-wrap: wrap;
    gap: 15px;
  }

  @media (min-width: 800px) {
    justify-content: space-between;
    align-items: flex-start;
    gap: 30px;
  }
`;

const CadastroDadosCotas: React.FC = () => (
  <ContainerComponente>
    <ViewAppBar />
    <ViewCadastroCotas />
    <ViewFooter />
  </ContainerComponente>
);
export default CadastroDadosCotas;
